import { render } from "./Feedback.vue?vue&type=template&id=14f73d42&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=14f73d42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14f73d42"

export default script